import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

export const OutstandingReportsFeature: FeatureMetadata = {
  id: "outstanding-reports",
  moduleName: "feesFinance",
  navigation: {
    label: "Outstanding Reports",
    path: "/outstanding-reports",
    icon: ClipboardDocumentListIcon,
    order: 3,
    parentId: "finance-reports",
  },
  route: {
    path: "/outstanding-reports",
    element: lazy(() => import("./pages/OutstandingReport")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FinanceReports", {
    create: permissionId("FeeFinance", "FinanceReports", "analytics"),
    edit: permissionId("FeeFinance", "FinanceReports", "analytics"),
    delete: permissionId("FeeFinance", "FinanceReports", "analytics"),
  }),
  readiness: "live",
};
